export default "__VITE_ASSET__8354c00f__"